export * from "./servicesImpressionsInsight";
export * from "./servicesViewsInsight";
export * from "./servicesPurchasesInsight";
export * from "./servicesConversionInsight";
export * from "./clientsByLocationInsight";
export * from "./clientsByIndustryInsight";
export * from "./clientNewAndRecurringInsight";
export * from "./clientActivityHoursInsight";

export enum AnalyticsPeriodEnum {
  MONTH = "MONTH",
  THREE_MONTH = "THREE MONTH",
  YEAR = "YEAR",
}

export type InsightCommonParams = {
  period: AnalyticsPeriodEnum;
  serviceId?: string;
};

export type InsightCommonData = {
  mainValue: number;
  secondaryValue: number;
  xValues: string[];
  yValues: number[];
  XYValues: { x: string; y: number }[];
};
